import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import '../ForgotPassword/styles.scss';

const MODES = {
  confirm: {
    title: 'Confirm your new email',
    button: 'Confirm',
    success: ({ email }) => `Your email is now ${email}. Use it next time you sign in.`,
  },
  cancel: {
    title: 'Cancel the email change',
    button: 'Cancel',
    success: () => "The email change was cancelled. If you didn't request it, reset your password.",
  },
};

const INVALID_LINK = 'This link is invalid or was already used';

const EmailChange = ({ mode }) => {
  const { title, button, success } = MODES[mode];
  const [params] = useSearchParams();
  const token = params.get('token');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(token ? null : { text: INVALID_LINK, final: true });

  // runs only on click: mail scanners pre-open links
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/email-change/${mode}`,
        null,
        { headers: { 'X-Email-Change-Token': token } }
      );
      setResult({ text: success(data), final: true });
    } catch (e) {
      const message = e.response?.data?.message;
      setResult({ text: message || 'Something went wrong. Try again.', final: !!message });
    }
    setBusy(false);
  };

  return (
    <section className={'auth-wrapper'}>
      <Link to="/signin" replace className={'back-link'}>
        {'< Back to Sign In page'}
      </Link>
      <div className={'auth-block'}>
        <h2 className={'auth-title'}>3208 Technology, Inc.</h2>
        <div className={'auth-form'}>
          <p className={'auth-form-title'}>{title}</p>
          {result && <p className={'auth-form-info'}>{result.text}</p>}
          {!result?.final && (
            <button className={'auth-btn'} disabled={busy} onClick={submit}>
              {button}
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default EmailChange;
